// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWeatherSunIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M4 12a1 1 0 0 1-1 1H2a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m18-1h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2M12 4a1 1 0 0 0 1-1V2a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1M4.93 17.66l-.71.7a1.004 1.004 0 0 0 1.42 1.42l.7-.71a1 1 0 0 0-1.41-1.41M19.07 6.34l.71-.7a1.005 1.005 0 0 0-.71-1.714 1 1 0 0 0-.71.294l-.7.71a1 1 0 0 0 1.41 1.41m-14.14 0a1 1 0 0 0 1.41-1.41l-.7-.71a1.004 1.004 0 0 0-1.42 1.42zM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0m1.12 5.66a1 1 0 0 0-1.41 1.41l.7.71a1.004 1.004 0 1 0 1.42-1.42zM12 20a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" />
  </g>
);
export default SvgWeatherSunIcon;
SvgWeatherSunIcon.displayName = 'SvgWeatherSunIcon';
